import { Popper, type PopperProps, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import type React from "react";

interface IPopperProps extends PopperProps {
  width: string;
}

const PREFIX_TEXFIELD = "TextFieldStyled";
const PREFIX_POPOVER = "PopoverStyled";

export const classesTextfield = {
  rootTextField: `${PREFIX_TEXFIELD}-rootTextField`,
  iconSearch: `${PREFIX_TEXFIELD}-iconSearch`,
  arrowBtn: `${PREFIX_TEXFIELD}-arrowBtn`,
};

export const classesPopover = {
  rootPopper: `${PREFIX_POPOVER}-rootPopper`,
  paperContainer: `${PREFIX_POPOVER}-paperContainer`,
  romeCheckboxDiv: `${PREFIX_POPOVER}-romeCheckboxDiv`,
  appellationCheckboxDiv: `${PREFIX_POPOVER}-appellationCheckboxDiv`,
  checkbox: `${PREFIX_POPOVER}-checkbox`,
  buttonAllAppellation: `${PREFIX_POPOVER}-buttonAllAppellation`,
  actions: `${PREFIX_POPOVER}-actions`,
  buttonSave: `${PREFIX_POPOVER}-buttonSave`,
  buttonCancel: `${PREFIX_POPOVER}-buttonCancel`,
  noOption: `${PREFIX_POPOVER}-noOption`,
  moreOption: `${PREFIX_POPOVER}-moreOption`,
  listRome: `${PREFIX_POPOVER}-listRome`,
  appellationList: `${PREFIX_POPOVER}-appellationList`,
  divider: `${PREFIX_POPOVER}-divider`,
};

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  [`&.${classesTextfield.rootTextField}`]: {
    "& .MuiOutlinedInput-input": {
      paddingLeft: 0,
    },
  },
  [`& .${classesTextfield.iconSearch}`]: {
    width: "18px",
  },
  [`& .${classesTextfield.arrowBtn}`]: {
    left: theme.spacing(0),
    "&.MuiIconButton-root": {
      padding: "2px",
    },
  },
}));

export const PopperStyled = styled<React.FC<IPopperProps>>(Popper, {
  shouldForwardProp: (prop) => prop !== "width",
})(({ theme, width }) => ({
  [`&.${classesPopover.rootPopper}`]: {
    zIndex: 10,
  },
  [`& .${classesPopover.paperContainer}`]: {
    backgroundColor: "white",
    width: width,
  },
  [`& .${classesPopover.noOption}`]: {
    padding: `${theme.spacing(1)}`,
  },
  [`& .${classesPopover.moreOption}`]: {
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(1.8),
    cursor: "pointer",
  },
  [`& .${classesPopover.romeCheckboxDiv}`]: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(1),
    alignItems: "center",
    flexBasis: "100%",
  },
  [`& .${classesPopover.appellationCheckboxDiv}`]: {
    flexDirection: "row",
    marginLeft: theme.spacing(1),
    alignItems: "center",
    flexBasis: "100%",
  },
  [`& .${classesPopover.checkbox}`]: {
    padding: theme.spacing(0.5),
    "& .MuiSvgIcon-root": { fontSize: 12 },
  },
  [`& .${classesPopover.actions}`]: {
    display: "flex",
    justifyContent: "flex-end",
    flexBasis: "100%",
    padding: theme.spacing(2),
    ["& #validate-romeLibelle-appellationList"]: {
      padding: theme.spacing(0),
      backgroundColor: "transparent",
    },
    ["& #cancel-romeLibelle-appellationList"]: {
      backgroundColor: "transparent",
    },
  },
  [`& .${classesPopover.listRome}`]: {
    padding: `0 ${theme.spacing(2)}`,
    maxHeight: "350px",
    overflow: "auto",
  },
  [`& .${classesPopover.appellationList}`]: {
    "& .MuiCheckbox-root": {
      padding: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
    },
  },
  [`& .${classesPopover.divider}`]: {
    marginTop: theme.spacing(1),
  },
}));
